export default __webpack_public_path__ + "static/media/soyl_family.015aff85.png";